import { render, staticRenderFns } from "./SelectionBlock.vue?vue&type=template&id=2ea4d98f&scoped=true"
import script from "./SelectionBlock.vue?vue&type=script&lang=ts"
export * from "./SelectionBlock.vue?vue&type=script&lang=ts"
import style0 from "./SelectionBlock.vue?vue&type=style&index=0&id=2ea4d98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea4d98f",
  null
  
)

export default component.exports